
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Navbar from "../../components/Bar/Navbar";
import Card from "../../components/card/Card";
import Footer from "../../components/footer/Footer";
import TransactionTables from "../../components/Transactiontables/TransactionTables";
import { getReversedHistoryData } from "../../Redux/apiCalls";
import {
  CardContainer,
  Container,
  Desc,
  DescP,
  DescSpan,
  H3,
  Wrapper,
} from "./transHistory.styles";

const ReversedTransHistory = () => {
  const { reversedTransHistory, isProcessing } = useSelector(
    (state) => state.transaction
  );

  const dispatch = useDispatch();
  const [itemOffset, setItemOffset] = useState(0);
  const [pageCount, setPageCount] = useState(reversedTransHistory?.to);
  const [currentItems, setCurrentItems] = useState(reversedTransHistory?.data);
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 10;

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(
      reversedTransHistory?.data && reversedTransHistory?.data.slice(itemOffset, endOffset)
    );
    setPageCount(Math.ceil(reversedTransHistory?.to / itemsPerPage));
  }, [itemOffset, reversedTransHistory, itemsPerPage]);

  const handlePageClick = (event) => {
    const newOffset =
      (event.selected * itemsPerPage) % reversedTransHistory?.data.length;
    setItemOffset(newOffset);
    setCurrentPage(event.selected + 1);
  };

  useEffect(() => {
    getReversedHistoryData(dispatch, currentPage);
  }, [dispatch, currentPage]);


  return (
    <>
      <Navbar />
      <Container>
        <Wrapper>
          <Desc>
            <H3>Reversed Transaction List</H3>
            <DescP>
              Transaction / <DescSpan>Reversed Transactions List</DescSpan>
            </DescP>
          </Desc>
          <CardContainer>
            <Card type="totalTransactions" />
            <Card type="transactionToday" />
            <Card type="transactionYesterday" />
            <Card type="transactionAgo" />
          </CardContainer>

          {/* TABLES */}
          <TransactionTables
            transHistory={reversedTransHistory}
            pageCount={pageCount}
            currentItems={currentItems}
            handlePageClick={handlePageClick}
            currentPage={currentPage}
            isProcessing={isProcessing}
          />
        </Wrapper>
      </Container>
      <Footer />
    </>
  );
};

export default ReversedTransHistory;
